import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const DropdownWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const IndustryChartFallback = styled('div')`
  height: 324px;
  ${media.smDown`
    height: 280px;
  `}
`;
